<script setup lang="ts">
interface Props {
  title?: string
  icon?: string
}

defineProps<Props>()
defineOptions({ inheritAttrs: false })
</script>

<template>
  <div class="flex items-center gap-1">
    <div
      class="flex items-center font-light text-sm text-nowrap text-gray-700 dark:text-gray-400"
      v-bind="$attrs"
    >
      <span>{{ title }}</span>
    </div>
    <div class="border-t border-gray-200 w-full"></div>
    <slot></slot>
  </div>
</template>
